import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import {init} from './config';

import React from 'react';
import ReactDOM from 'react-dom/client';

import 'moment/locale/fr';
import 'moment/locale/en-gb';
import 'moment/locale/de';

import './index.css';
import {configureStore} from './configureStore';
import i18n from './i18n';
import App from './App';
import {BglLogger, BglMonitor, PewClientConfig, PewClientContext} from '@bgl/lib-ts-integration';

const rootElement = document.getElementById('fees-simulator');

const store = configureStore();

(async (elem, lng) => {
    if (!elem) return;

    init();

    await PewClientContext.init();
    await i18n.changeLanguage(lng);

    const logger = BglLogger.getInstance();
    BglMonitor.getInstance().setMonitoringDefaultContext();
    logger.info(`Starting ${PewClientConfig.config.appName} in version ${PewClientConfig.config.appVersion}`);

    const root = ReactDOM.createRoot(elem);
    root.render(<App store={store} lng={lng}/>);
})(rootElement, rootElement?.dataset.lng || 'fr');



